import { OrdemProducaoRepository } from "../repository/ordem_producao_repository";

export class OrdemProducaoService {
	constructor() {
		this.ordemProducaoRepository = new OrdemProducaoRepository();
	}

	async save(data) {
		return await this.ordemProducaoRepository.save(data);
	}

	async getAll(unidadeDistribuidoraId, search) {
		return await this.ordemProducaoRepository.getAll(unidadeDistribuidoraId, search);
	}

	async getProdutosDisponiveis(unidadeDistribuidoraId, excluirOrdemId) {
		return await this.ordemProducaoRepository.getProdutosDisponiveis(
			unidadeDistribuidoraId,
			excluirOrdemId
		);
	}

	async getById(id) {
		return await this.ordemProducaoRepository.getById(id);
	}

	async delete(id) {
		return await this.ordemProducaoRepository.delete(id);
	}
}
